module.exports = __webpack_public_path__ + "static/media/nav-nike.0428afb1.svg";